import authHeader from './auth-header';
import Api from './api';

const API_URL = process.env.REACT_APP_AQUA_API_ENDPOINT

class RoleService {
	
  async getRoleById(roleId: string) {
	return await Api().get(`${API_URL}/role/${roleId}`, { headers:  authHeader() as any });      
  }
  async find(term: string) {
    return await Api().get(`${API_URL}/role/find?text=${term}%`, { headers:  authHeader() as any });      
  }

  async updateRole(role: any) {
    return await Api().put(`${API_URL}/role/${role.id}`, role, 
    { method: 'PUT',
      headers:  authHeader() as any });      
  }

  async createRole(role: any) {
    return await Api().post(`${API_URL}/role/`, role, 
    { method: 'POST',
      headers:  authHeader() as any });      
  }

  async deleteRole(role: any) {
    return await Api().delete(`${API_URL}/role/${role.id}`, 
    { method: 'DELETE',
      headers:  authHeader() as any });      
  }  

  async getMetadata() {
    return await Api().get(`${API_URL}/role/metadata`, { headers:  authHeader() as any });      
  }  
}

export default new RoleService();